export type Defect = {
    id: string;
    description: string;
};

export const visualDefectsData: Record<string, Defect[]> = {
    BACK: [
        { id: "B1", description: "Wrinkles" },
        { id: "B2", description: "Peel Off" },
        { id: "B3", description: "Scratches" },
        { id: "B4", description: "Over Trim" },
        { id: "B5", description: "Bubbles on BackSheet" },
        { id: "B6", description: "Dents" },
        { id: "B7", description: "Holes, Puncture" },
        { id: "B8", description: "Backsheet Imprints" },
    ],
    CELL: [
        { id: "C1", description: "Cell Crack" },
        { id: "C2", description: "Edge Chips" },
        { id: "C3", description: "Cell Scratches" },
        { id: "C4", description: "Non Uniform Color" },
        { id: "C5", description: "Cell Chips" },
        { id: "C6", description: "Cell Gap" },
        { id: "C7", description: "Cell Dirty" },
        { id: "C12", description: "Loose Cell Fragments" },
    ],
    GLASS: [
        { id: "G1", description: "Glass Edge Chips" },
        { id: "G2", description: "Glass Surface Chips" },
        { id: "G3", description: "Glass Crack" },
        { id: "G4", description: "Glass Scratches" },
        { id: "G5", description: "Glass Stains" },
        { id: "G6", description: "Glass Bubbles" },
    ],
    JBOX: [
        { id: "J1", description: "CC Bubbles" },
        { id: "J2", description: "Not Enough Potting" },
        { id: "J3", description: "Too Much Potting" },
        { id: "J4", description: "Misaligned JBox" },
        { id: "J5", description: "Lifted JBox" },
        { id: "J6", description: "Not Enough Sealant" },
        { id: "J7", description: "Broken JBox" },
        { id: "J8", description: "Broken Connectors or Cables" },
        { id: "J9", description: "Exposed CC" },
        { id: "J10", description: "Spacer" },
        { id: "J11", description: "JBox Imprint" },
        { id: "J12", description: "Potting Not Cured" },
        { id: "J13", description: "Unsoldered CC" },
        { id: "J14", description: "Dirty Backsheet" },
        { id: "J15", description: "Too much Sealant" },
        { id: "J16", description: "Repaired JBox" },
        { id: "J17", description: "Bad JBox Soldering" },
    ],
    LAMI: [
        { id: "L1", description: "Edge Distance to CC < 12mm" },
        { id: "L2", description: "Single Bubbles" },
        { id: "L3", description: "Group Bubbles" },
        { id: "L4", description: "Encap Delamination" },
        { id: "L5", description: "Foreign Material Conductive" },
        { id: "L6", description: "Foreign Material Non Conductive" },
        { id: "L7", description: "Flux Stain" },
        { id: "L8", description: "String Gap" },
        { id: "L9", description: "Bubbles at Jbox Holes" },
        { id: "L10", description: "CC Press Mark" },
        { id: "L11", description: "Cell on Jbox Hole" },
        { id: "L12", description: "Edge Bubbles" },
        { id: "L13", description: "Corner Delam" },
        { id: "L14", description: "Edge Distance to Cell < 12mm" },
        { id: "L15", description: "Too long in Lami" },
    ],
    SOLDERING: [
        { id: "S1", description: "Ribbon Shift" },
        { id: "S2", description: "Misaligned Ribbon to CC" },
        { id: "S3", description: "Missing Ribbon" },
        { id: "S4", description: "Ribbon Excess Length" },
        { id: "S5", description: "Missing CC" },
        { id: "S6", description: "CC Burnt Marks" },
        { id: "S7", description: "CC Mislocated Coating Removal" },
        { id: "S8", description: "CC Color Peel Off" },
        { id: "S9", description: "CC Multi Stack" },
        { id: "S10", description: "CC Coating Scratches" },
        { id: "S11", description: "CC Edge Cutting Issue" },
        { id: "S13", description: "CC to CC Distance" },
        { id: "S14", description: "Ribbon Too Short" },
        { id: "S15", description: "Overlapping Crossconnector" },
    ],
    OTHERS: [
        { id: "M1", description: "Other Optical defects not defined" },
        { id: "M2", description: "Wrong build, Assembly issues" },
    ],
};

export const elDefectsData: Record<string, Defect[]> = {
    CELL: [
        { id: "C1", description: "Cell Crack" },
        { id: "C3", description: "Cell Scratches" },
        { id: "C5", description: "Cell Chips" },
        { id: "C8", description: "Cell Broken" },
        { id: "C9", description: "Broken Finger" },
        { id: "C10", description: "Shorted/Dark Cell" },
        { id: "C11", description: "Bright Cell Spot" },
        { id: "C12", description: "Loose Cell Fragments" },
    ],
    MODULE: [
        { id: "M1", description: "Dark Module" }
    ],
    SOLDERING: [
        { id: 'S12', description: 'CC Bad Soldering' },
        { id: 'ST2', description: 'Stringer Bad Solder' },
        { id: 'ST1', description: 'Dark String' },
    ],
    OTHERS: [
        {id: 'M3', description: 'Low Power'},
        {id: 'M4', description: 'Low Isc'},
        {id: 'M5', description: 'Low Voc'},
        {id: 'M6', description: 'Other EL defects not defined'},
        {id: 'M7', description: 'Other Flash defects not defined'},
    ]
}
